import { useMemo } from 'react'
import { StockType } from 'types/stock'
import { parseToDate } from 'lib/helper'
import { StoreCalendarType } from 'types/storeCalendar'
import { DayOfWeekType, DaysOfWeek } from 'lib/daysOfWeek'
import { CheckoutItemType } from 'types/checkoutItem'
import { SpecialHolidayType } from 'types/calendar'
const daysOfWeek = new DaysOfWeek()

// 追加された定休日に対して削除が必要な在庫データを取得
const useConfirmDeletedStocks = (
  stocks: StockType[],
  storeCalendars: StoreCalendarType[],
  addedHolidays: DayOfWeekType[],
  addedCloseStoreCalendars: StoreCalendarType[],
  checkoutItems: CheckoutItemType[],
  specialHolidays: SpecialHolidayType[]
): StockType[] => {
  return useMemo(() => {
    const _stocks: StockType[] = []
    if (!stocks || !storeCalendars || !addedHolidays || !addedCloseStoreCalendars || !checkoutItems) return _stocks

    const openStoreCalendars = storeCalendars.filter((storeCalendar) => storeCalendar.status === 'open')

    for (let i = 0; i < stocks.length; i = (i + 1) | 0) {
      const stock = { ...stocks[i] }

      // 注文のある日付は臨時営業日になるので削除しない
      if (
        checkoutItems.some((item) => {
          return item.date === stock.date && item.bread_ref.id === stock.bread_ref.id
        })
      )
        continue

      // 追加された定休日に販売予定であり臨時営業日に販売予定でなければ削除
      if (
        addedHolidays.includes(daysOfWeek.getDayOfWeek(parseToDate(stock.date), specialHolidays)) &&
        openStoreCalendars.every((storeCalendar) => storeCalendar.date !== stock.date)
      ) {
        _stocks.push(stock)
      }
      // 追加された臨時休業日に販売予定であれば削除する
      if (addedCloseStoreCalendars.some((storeCalendar) => storeCalendar.date === stock.date)) {
        _stocks.push(stock)
      }
    }
    return _stocks
  }, [stocks, storeCalendars, addedCloseStoreCalendars, addedHolidays, checkoutItems, specialHolidays])
}

export default useConfirmDeletedStocks
